import { SanmarPoItemVariant } from "./sanmar-po-item-variant";

export class SanmarPoItemDetails {

    poStyle: string;
    deliveryDate: string;
    currency: string;

    SanmarpoItemVariantDetails: SanmarPoItemVariant[]

}